
import Vue from 'vue'
import App from './App.vue'

import router from './router/router'
import store from './store'
import Tools from './utils/tools'
import Utils from './utils/utils'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/main.less'
import { install as Axios } from './api'
import API from './api/url'
Vue.use(ElementUI);
Vue.use(Axios);

import animate from 'animate.css'
Vue.use(animate)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/images/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/images/loading.gif'),
  //尝试加载几次
  attempt: 1
});

import moment from 'moment'
Vue.prototype.$moment = moment

document.title = "深圳市极智数字科技有限公司"

Vue.prototype.API = API
Vue.prototype.Tools = Tools
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (createElement) {
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    return createElement(App);
  },
  created: function () {
    Utils.initRem()
    Utils.browser()
  }  
}).$mount('#app')


